module.exports = __webpack_public_path__ + "img/calendar3-event-fill.1d798a86.svg";